// RITA-1549 — Drucken der Vertragserstellung (Backend: printContractCreation, reprintContractCreation,
// getContractCreationPrintLog; nur Super-Admins). Die Variablen tragen die Beraternummer; die Berater-UUID für das
// Neuladen der Liste „Dokumente“ kommt mit der Antwort (`agent_uuid`). Die Operationen sind benannt, weil die
// Tests der Seiten sie am Namen erkennen (definitions[0].name.value).
// RITA-1552: EINTRAG_FELDER fragt jedes Feld des geteilten Typs ContractCreationPrintLogEntry ab, auch den
// Vertragsbezug contract_entry_id (sonst wäre er zur Laufzeit undefined statt number | null). Eine neue Spalte im
// Protokoll braucht hier denselben Eintrag wie CONTRACT_CREATION_PRINT_LOG_ATTRIBUTES im Druckdienst.
// RITA-1552 (Entscheidung E6, Befund F1 aus dem Review von MR 1): printVertrag schickt immer
// `expected_contract_entry_id` mit – beim Druck der Rücksendung die Kennung des „Gehört zu“-Vertrags oder ausdrücklich
// null (kein Vertrag aus dem PRM). Fehlt der Wert, nimmt der Server null an und lehnte jede Rücksendung zu einem
// gedruckten Vertrag mit CONTRACT_CHANGED ab. Beim Druck von Anschreiben Versand und/oder Vertrag wertet der Server ihn
// nicht aus (null). Die Rücksendung druckt über dieselbe Operation; ERGEBNIS_FELDER nutzt auch der Scan
// (api/vertragsruecklauf.ts).
import { gql } from '@apollo/client';
import type {
  ContractCreationPrintInput,
  ContractCreationPrintLogEntry,
  ContractCreationPrintResult,
} from 'global-intern-types';

export type Druckeintrag = ContractCreationPrintLogEntry;
export type Druckantwort = ContractCreationPrintResult;

export interface DruckprotokollAntwort {
  getContractCreationPrintLog: Druckeintrag[];
}

export interface DruckprotokollVariablen {
  agent_id: number;
}

export interface DruckVariablen {
  agent_id: number;
  input: ContractCreationPrintInput;
  /**
   * Entwurf, der mit dem Druck erledigt wird; null = ein vorhandener Entwurf bleibt unberührt (F10: das Fenster
   * schickt immer null, die Bearbeiten-Seite nur bei vollständiger Auswahl die Revision ihrer Sitzung, F11).
   */
  expected_revision: string | null;
  /**
   * RITA-1552 (E6): Nur bei der Rücksendung ausgewertet – der Druck mit Vertrag, zu dem sie laut Fenster bzw. Seite
   * gehört, oder null (kein Vertrag aus dem PRM). Ist inzwischen ein anderer Vertrag der neueste, druckt der Server
   * nicht (CONTRACT_CHANGED). Pflichtfeld, damit kein Druckweg den Wert vergisst (Befund F1); beim Vertrag null.
   */
  expected_contract_entry_id: number | null;
}

export interface ErneutDruckenVariablen {
  agent_id: number;
  entry_id: number;
}

export interface DruckMutationAntwort {
  printContractCreation: Druckantwort;
}

export interface ErneutMutationAntwort {
  reprintContractCreation: Druckantwort;
}

const EINTRAG_FELDER = `
  id
  agent_id
  entry_type
  created_at
  created_by_name
  file_id
  filename
  file_name
  parent_id
  superseded_by
  contract_entry_id
  template_changed
  documents {
    kind
    template_id
    template_name
    template_updated_at
  }
`;

/** Felder der Antwort auf Drucken, Erneut drucken und (RITA-1552) das Hochladen des Scans. */
export const ERGEBNIS_FELDER = `
  entry {
    ${EINTRAG_FELDER}
  }
  file_id
  filename
  file_name
  agent_uuid
`;

export const GET_DRUCKPROTOKOLL = gql`
  query getDruckprotokoll($agent_id: Int!) {
    getContractCreationPrintLog(agent_id: $agent_id) {
      ${EINTRAG_FELDER}
    }
  }
`;

export const PRINT_VERTRAG = gql`
  mutation printVertrag(
    $agent_id: Int!
    $input: ContractCreationPrintInput!
    $expected_revision: String
    $expected_contract_entry_id: Int
  ) {
    printContractCreation(
      agent_id: $agent_id
      input: $input
      expected_revision: $expected_revision
      expected_contract_entry_id: $expected_contract_entry_id
    ) {
      ${ERGEBNIS_FELDER}
    }
  }
`;

export const REPRINT_VERTRAG = gql`
  mutation reprintVertrag($agent_id: Int!, $entry_id: Int!) {
    reprintContractCreation(agent_id: $agent_id, entry_id: $entry_id) {
      ${ERGEBNIS_FELDER}
    }
  }
`;
